import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ArticleTableComponent, ArticleTableExpandedDirective } from '@foundation/articles/ui';
import { ConversationDisplayerComponent } from '@foundation/conversations/ui';
import { TranslateDirective, TranslatePipe } from '@foundation/translations/services';
import { SanitizeHtmlPipe } from '@foundation/utils';

@Component({
	selector: 'lib-admin-tickets-page',
	imports: [CommonModule, ArticleTableComponent, ArticleTableExpandedDirective, ConversationDisplayerComponent, SanitizeHtmlPipe, TranslateDirective, TranslatePipe],
	templateUrl: './admin-tickets-page.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminTicketsPageComponent {}
